/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSimilarItemsFooter_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGrid_user">;
    readonly " $refType": "PdpRespSimilarItemsFooter_user";
};
export type PdpRespSimilarItemsFooter_user$data = PdpRespSimilarItemsFooter_user;
export type PdpRespSimilarItemsFooter_user$key = {
    readonly " $data"?: PdpRespSimilarItemsFooter_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemsFooter_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '1f48f572fba0d7a4547a23c81ca621dc';
export default node;
